import React, { useEffect } from 'react';

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getSelf } from '@vlabs/api/artemy/client';
import { WhiteLabelBrand } from '@vlabs/monokit/shared/ui/white-label-brand';
import { ChangeUserPasswordPage } from '@vlabs/pages/point';
import { usePermissionContext } from '@vlabs/permissions';
import { ThemeProvider } from '@vlabs/shared/context/ThemeContext';
import ScrollToTop from '@vlapps/point/src/components/scroll-to-top/ScrollToTop';
import 'i18next';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import st from './App.module.sass';
import { PointNavbar } from './navigation';
import { PointRouter } from './router';
import { LoginPage } from '../pages/login-page/LoginPage';

function App(): React.JSX.Element {
  const { data: self, isLoading } = useQuery({
    queryKey: ['self'],
    queryFn: getSelf,
    staleTime: Infinity,
    retry: false,
  });
  const isAuthenticated = !!self;

  const queryClient = useQueryClient();
  const { refetch: refetchPermissions } = usePermissionContext();
  // После logout права сбрасываются в null — при следующем логине их нужно перезапросить
  const hasPermissionsData = queryClient.getQueryData(['permissions', 'point3']) != null;
  const isFirstRenderRef = React.useRef(true);

  useEffect(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return;
    }
    if (isAuthenticated && !hasPermissionsData) {
      refetchPermissions();
    }
  }, [isAuthenticated, hasPermissionsData, refetchPermissions]);

  if (isLoading) return null;

  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className={st.App}>
          <ScrollToTop />
          <Switch>
            <Route
              component={ChangeUserPasswordPage}
              path="/auth/password-reset"
            />
            <Route
              path="*"
              render={(props) => {
                if (!isAuthenticated) {
                  return (
                    <LoginPage
                      {...props}
                      CustomBrand={<WhiteLabelBrand style={{ backgroundPosition: 'center' }} />}
                    />
                  );
                }

                return (
                  <React.Fragment>
                    <PointNavbar />
                    <PointRouter />
                  </React.Fragment>
                );
              }}
            />
          </Switch>
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
